/** IDX Exchange (external trading app — Trade perps + Swap spot) — shared URLs for nav, footer, SEO. */

/** Root trading app URL — no path segment (symbol lives in app localStorage). */
export const IDX_EXCHANGE_URL = "https://dex.idxsolana.io";
export const IDX_EXCHANGE_LEARN_MORE_PATH = "/exchange/learn-more";
